<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer010">
<p class="ch"><a id="_idTextAnchor000"></a>DAY ONE</p>
<p class="epigraph">“To be frank, reader, you’d be better off not visiting the city at all.”</p>
<p class="citation">—<em>The City of Sin, a Guidebook: Where To Go and Where Not To</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Day_One.vue?681d82ec